/* src/app/admin-setting/assing-company-users/company-users-list/update-sites-popup/update-sites-popup.css */
::ng-deep update-sites-popup.ng-star-inserted > div {
  margin-right: -24px;
  margin-left: -24px;
}
/*# sourceMappingURL=update-sites-popup.css.map */
